import useDefaultCallToAction from 'hooks/useDefaultCallToAction';
import { getValue } from 'utils/richTextUtils';

const addGlobalCta = (object) => {
  const columns = getValue(object, 'columns');

  columns?.forEach((column) => {
    column?.items?.forEach((item) => {
      if (item?.__typename === 'ContentfulCallToAction') {
        const cta = { ...useDefaultCallToAction(), templateId: item.templateId };
        const index = column.items.indexOf(item);

        column.items[index] = cta;
      }
    });
  });

  return object;
};

const getUnusedEntryTemplateIds = (data) => {
  if (data.componentMap) {
    const templateIds = data.componentMap.map((mapItem) => {
      const templateId = mapItem.split(':')[0];

      return templateId;
    });

    if (templateIds) {
      const unusedEntries = data.template?.rows?.flatMap((row) =>
        row.columns?.flatMap((column) =>
          column.items?.flatMap((item) => {
            if (item?.__typename === 'ContentfulRow') {
              return item.columns.flatMap((nestedColumn) =>
                nestedColumn?.items?.flatMap((nestedItem) => {
                  if (
                    !templateIds.includes(nestedItem?.templateId) &&
                    nestedItem?.__typename !== 'ContentfulRow'
                  ) {
                    return nestedItem;
                  }

                  return null;
                }),
              );
            }

            if (!templateIds.includes(item?.templateId) && item?.__typename !== 'ContentfulRow') {
              return item;
            }
            return null;
          }),
        ),
      );

      return unusedEntries.map((entry) => entry?.templateId);
    }
  }

  return [];
};

export const findAndReplace = (object, value, replacevalue, fields, remove) => {
  if (object) {
    const keys = Object.keys(object);

    keys.forEach((key) => {
      if (Object.hasOwnProperty.call(object, key)) {
        if (typeof object[key] === 'object') {
          findAndReplace(object[key], value, replacevalue, fields, remove);
        }
        const colIncludesValue = object.items?.some((item) => {
          if (item.templateId !== undefined) {
            return item.templateId === value;
          }
          return false;
        });

        const stylesIncludesValue =
          object.styles?.templateId !== undefined && object.styles?.templateId === value;

        const sectionIncludesValue = object.templateId !== undefined && object.templateId === value;

        if (colIncludesValue) {
          const columnItems = object.items;
          const foundItem = columnItems.find((item) => {
            if (item?.templateId !== undefined) {
              return item.templateId === value;
            }
            return false;
          });
          const index = columnItems.indexOf(foundItem);

          if (remove) {
            delete columnItems[index];
          }

          fields?.forEach((field) => {
            columnItems[index][field] = replacevalue[field];
          });

          object.items = columnItems;
        }

        if (stylesIncludesValue) {
          fields?.forEach((field) => {
            object.styles[field] = replacevalue[field];
          });
        }

        if (sectionIncludesValue) {
          fields?.forEach((field) => {
            if (object[field] != null && replacevalue[field] != null) {
              object[field] = replacevalue[field];
            }
          });
        }
      }
    });
  }
};

const transformTemplateData = (data, unusedIds) => {
  const immutableData = JSON.parse(JSON.stringify(data));
  const { template } = data;
  const keys = Object.keys(data);

  const templateWithCta = addGlobalCta(template);

  keys.forEach((key) => {
    if (
      key !== 'template' &&
      key !== 'templateName' &&
      key !== 'variation' &&
      key !== '__typename'
    ) {
      const entry = data[key];

      const getMatchedComponent = (item) => {
        let mapComponent;
        let mapTemplateId;

        data?.componentMap?.forEach((componentValues) => {
          const [templateId, contentfulId] = componentValues.split(':');

          if (contentfulId?.trim() === item.contentful_id) {
            mapComponent = item;
            mapTemplateId = templateId;
          }
        });

        return { mapTemplateId, mapComponent };
      };

      if (entry) {
        if (Array.isArray(entry)) {
          entry?.forEach((item) => {
            const fields = Object.keys(item);
            let { templateId } = item;
            let component = {
              ...item,
              isHero: template?.isHero,
            };

            const { mapTemplateId, mapComponent } = getMatchedComponent(item);

            if (mapTemplateId && mapComponent) {
              templateId = mapTemplateId;
              component = {
                ...mapComponent,
                isHero: templateWithCta?.isHero,
              };
            }

            findAndReplace(template, templateId, component, [fields, 'isHero'].flat());
          });
        } else {
          let fields;
          if (entry.__typename === 'ContentfulSection') {
            fields = Object.keys(entry)?.filter((entryKey) => entryKey !== 'rows');
          } else {
            fields = Object.keys(entry);
          }

          const { templateId, component } = getMatchedComponent(entry);

          findAndReplace(
            templateWithCta,
            templateId || entry.templateId,
            component || entry,
            fields,
          );
        }
      }
    }
  });

  const idsToRemove = unusedIds?.length > 0 ? unusedIds : getUnusedEntryTemplateIds(immutableData);

  idsToRemove?.forEach((templateId) => {
    if (templateId) {
      findAndReplace(templateWithCta, templateId, null, null, true);
    }
  });

  return template;
};

export default transformTemplateData;
